// Add your custom JS here.

jQuery(document).on('gform_post_render', function(event, form_id, current_page){
  jQuery('.gfield_label').removeAttr('style');
  jQuery('.gfield_label').addClass('d-block mt-0');
});

// iframe video play jQuery
 jQuery(document).ready(function () {
    jQuery('.play-video').on('click', function (e) {
      e.preventDefault();

      var videoUrl = jQuery(this).data('video');

      // Add autoplay
      videoUrl += videoUrl.indexOf('?') > -1 ? '&autoplay=1' : '?autoplay=1';

      // Create the iframe
      var iframe = `
        <iframe src="${videoUrl}" 
                frameborder="0" 
                allow="autoplay; encrypted-media" 
                allowfullscreen>
        </iframe>`;

      // Stop other videos by restoring their thumbnails (or clearing the iframe)
      jQuery('.video-thumb').each(function () {
        if (!jQuery(this).has(jQuery(e.target)).length) {
          // Optionally, you can restore a thumbnail here instead of just clearing
          jQuery(this).html(jQuery(this).data('thumb-html')); // If saved earlier
        }
      });

      // Save the original thumbnail if needed
      var $thumbContainer = jQuery(this).closest('.video-thumb');
      if (!$thumbContainer.data('thumb-html')) {
        $thumbContainer.data('thumb-html', $thumbContainer.html());
      }

      // Replace current thumbnail with iframe
      $thumbContainer.html(iframe);
    });
});

// End iframe video play jQuery